import React, { useState } from "react";
import { observer } from "mobx-react";
import SparkleIcon from "Components/common/SparkleIcon";
import userDetail from "Stores/userDetail";
import copilotStore from "Stores/copilotStore";
import { PROMPT_OPENERS } from "../agent/promptSuggestions";

// Blank-state content: a rotating sample of the prompt bank (fresh set per
// visit, so the hero doesn't go stale) + the user's two most recent chats
// for one-click resume. Prompt rows PREFILL the composer for editing.
const HERO_PROMPT_COUNT = 6;

// Icon per prompt intent — six identical magnifiers read as lorem ipsum.
const promptIcon = prompt => {
  const lower = prompt.toLowerCase();
  if (/sequence|outreach|meeting/.test(lower)) return "send";
  if (/inbox|repl|opened/.test(lower)) return "mail";
  if (/export|crm|salesforce/.test(lower)) return "cloud_upload";
  if (/list|save|add|exclude/.test(lower)) return "playlist_add";
  if (/credit/.test(lower)) return "toll";
  if (/people|decision|leaders|vps|cxo|joined|hiring/.test(lower)) return "group";
  return "search";
};

const samplePrompts = () =>
  [...PROMPT_OPENERS].sort(() => Math.random() - 0.5).slice(0, HERO_PROMPT_COUNT);

const greetingWord = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Morning";
  if (hour < 17) return "Afternoon";
  return "Evening";
};

export const CopilotGreeting = observer(() => {
  const firstName = userDetail?.userInfo?.firstName || "";
  return (
    <div className="copilotHero__greeting">
      <span className="copilotHero__spark">
        <SparkleIcon />
      </span>
      <h1>
        {greetingWord()}
        {firstName ? `, ${firstName}` : ""}
      </h1>
    </div>
  );
});

export const CopilotCapabilities = observer(() => {
  const [prompts] = useState(samplePrompts);
  const recents = copilotStore.conversations.slice(0, 2);

  return (
    <div className="copilotHero__below">
      <div className="copilotHero__promptsLabel">Try asking</div>
      <div className="copilotHero__prompts">
        {prompts.map(prompt => (
          <button
            type="button"
            key={prompt}
            className="copilotHero__prompt"
            onClick={() => copilotStore.sendUserMessage(prompt)}
          >
            <i className="material-icons-outlined">{promptIcon(prompt)}</i>
            <span>{prompt}</span>
          </button>
        ))}
      </div>
      {recents.length > 0 && (
        <>
          <div className="copilotHero__promptsLabel">Pick up where you left off</div>
          <div className="copilotHero__prompts">
            {recents.map(item => (
              <button
                type="button"
                key={item.id}
                className="copilotHero__prompt copilotHero__prompt--recent"
                onClick={() => copilotStore.loadConversation(item.id)}
              >
                <i className="material-icons-outlined">history</i>
                <span>{item.title || "Untitled chat"}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
});
